import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'
import OutputForm from './OutputForm'
import useProjectApi, { IProject } from '../../useProjectApi'

const ReadForm = ({ selectedAction, project }: { selectedAction: any; project: IProject }) => {
  const [outputValue, setOutputValue] = useState<any>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })
  const { getContractDetails } = useProjectApi()

  useEffect(() => {
    reset()
    setOutputValue(null)
  }, [selectedAction])

  const handleRun = async (data: any) => {
    try {
      setLoading(true)
      const outputValue = await getContractDetails({
        action: selectedAction.name,
        inputsObject: data,
        inputsKeys: data ? Object.keys(data) : [],
        project,
      })
      setOutputValue(outputValue)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      toast.error('Something went wrong. Please try again.')
    }
  }

  if (!selectedAction || !selectedAction.constant) {
    return null
  }

  return (
    <>
      {selectedAction.inputs?.length ? (
        <form className="grid w-full gap-4" onSubmit={handleSubmit((data) => handleRun(data))}>
          {selectedAction.inputs?.map((input: any, index: number) => (
            <WrappedInput
              key={index}
              label={input.name}
              placeholder={input.type}
              error={errors[input.name || 'account']}
              {...register(input.name || 'account', {
                required: 'Required field',
              })}
            />
          ))}
          <div className="flex flex-col">
            <Button name="Run" className="mt-4 self-end" loading={isLoading} disabled={!isValid} />
          </div>
        </form>
      ) : (
        <Button name="Run" className="mt-4 self-end" loading={isLoading} onClick={handleRun} />
      )}
      <OutputForm selectedAction={selectedAction} outputValue={outputValue} />
    </>
  )
}

export default ReadForm
